import React from 'react';

import { Box } from '@mui/material';

import { Resource } from '../../../../../common/constants/resource';

type AutoMedicalClaimsResultRowProps = {
  hasHit: boolean;
  hasClear: boolean;
};

export const AutoMedicalClaimsResultRow = ({
  hasHit,
  hasClear,
}: AutoMedicalClaimsResultRowProps) => {
  const resultText = hasHit ? 'HIT' : hasClear ? 'CLEAR' : 'NO HIT';
  const resultTypeClassName = hasHit ? 'hit' : hasClear ? 'clear' : 'no-hit';

  return (
    <Box className="auto-medical-claims-result-row">
      <div className="auto-medical-claims-result-label">
        {Resource.AUTO_MEDICAL_CLAIMS_ORDER_RESULT}
      </div>
      <Box
        className={`auto-medical-claims-result-value auto-medical-claims-result-value--${resultTypeClassName}`}
      >
        <span
          className={`auto-medical-claims-result-text auto-medical-claims-result-text--${resultTypeClassName}`}
        >
          {resultText}
        </span>
      </Box>
    </Box>
  );
};
